import React from 'react';
import { Switch, Tooltip } from '@mui/material';
import { changeThemeMode, ThemeModeSelector } from 'store/common';
import { useAppDispatch, useAppSelector } from 'hooks/store';

import useStyles from '../styles';

const ThemeSwitch: React.FC = () => {
  const dispatch = useAppDispatch();
  const themeMode = useAppSelector(ThemeModeSelector);
  const classes = useStyles();

  return (
    <div className={classes.themeSwitch}>
      <Tooltip title="Dark Mode">
        <Switch
          checked={themeMode === 'dark'}
          onClick={() => {
            dispatch(changeThemeMode(themeMode === 'light' ? 'dark' : 'light'));
          }}
          color="secondary"
        />
      </Tooltip>
    </div>
  );
};

export default ThemeSwitch;
